import { render, staticRenderFns } from "./guestCancelReport.vue?vue&type=template&id=67a72d82"
import script from "./guestCancelReport.vue?vue&type=script&lang=js"
export * from "./guestCancelReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports